<template>
  <div class="flex w-full items-center gap-4">
    <div>
      <jade-dropdown
        :allowedPlacements="['bottom-start']"
        @toggleOpen="open = !open"
        :open="open"
      >
        <template #trigger>
          <jade-action-button
            :disabled="loading"
            :active="!!selectedStatus"
            dropdownIndicator
          >
            {{ $t(selectedStatus?.label || 'status') }}
          </jade-action-button>
        </template>
        <jade-list-item
          v-for="option in statusFilterOptions"
          :key="option?.value"
          :variant="
            selectedStatus?.value === option?.value ? 'active' : 'primary'
          "
          :label="option.label"
          @onClick="applyFilterStatus(option)"
          @keyup.page-down="applyFilterStatus(option)"
          as="button"
        />
      </jade-dropdown>
    </div>
    <JadeInputField
      label=""
      size="medium"
      :value.sync="id"
      :placeholder="$t('placeholder')"
      :leadingItem="{ type: 'icon', content: 'action-search' }"
    >
    </JadeInputField>
    <JadeButton
      variant="primary-solid"
      size="medium"
      :disabled="loading"
      @click="searchClick"
      class="w-28"
    >
      {{ $t('search') }}
    </JadeButton>
  </div>
</template>

<script>
import { SERVICE_ORDERS_STATUS_FILTER_OPTIONS } from '../physical-world.filters'

import {
  JadeButton,
  JadeDropdown,
  JadeInputField,
  JadeActionButton,
  JadeListItem
} from '@jade'

export default {
  name: 'ServiceOrdersSearch',
  components: {
    JadeInputField,
    JadeButton,
    JadeActionButton,
    JadeDropdown,
    JadeListItem
  },
  props: {
    loading: Boolean
  },
  data () {
    return {
      statusFilterOptions: SERVICE_ORDERS_STATUS_FILTER_OPTIONS.map(value => ({
        label: this.$t(value.text),
        selected: false,
        value: value.id
      })),
      open: false,
      selectedStatus: null,
      id: ''
    }
  },
  computed: {
    hasFilter () {
      return !!this.status
    }
  },

  methods: {
    searchClick () {
      this.$emit('searchClick', this.id)
    },
    applyFilterStatus (status) {
      this.selectedStatus = this.selectedStatus === status ? null : status

      this.open = false

      this.$emit('searchStatus', this.selectedStatus)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "search": "Buscar",
      "placeholder": "Buscar por número do pedido",
      "status": "Status"
    },
    "en-US": {
      "search": "Search",
      "placeholder": "Search by order number",
      "status": "Status"
    }
  }
</i18n>
